/**
 * Hashes a string using SHA-256 and returns the hexadecimal representation
 * @param message - The string to hash
 * @returns A promise that resolves to the hexadecimal hash string
 */
export async function sha256Hash(message: string): Promise<string> {
  if (!message) return '';
  const normalizedMessage = message.toLowerCase().trim();
  const msgBuffer = new TextEncoder().encode(normalizedMessage);
  const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
  return hashHex;
}
